/**
 * @generated SignedSource<<a48e0caf51273c04384fa77405b19bd7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SetUserPrivacyAgreedInput = {
  clientMutationId?: string | null | undefined;
};
export type useSetUserPrivacyAgreedMutation$variables = {
  input: SetUserPrivacyAgreedInput;
};
export type useSetUserPrivacyAgreedMutation$data = {
  readonly setUserPrivacyAgreed: {
    readonly clientMutationId: string | null | undefined;
    readonly user: {
      readonly privacyAgreedAt: any | null | undefined;
      readonly updatedAt: any;
    } | null | undefined;
  } | null | undefined;
};
export type useSetUserPrivacyAgreedMutation = {
  response: useSetUserPrivacyAgreedMutation$data;
  variables: useSetUserPrivacyAgreedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "privacyAgreedAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSetUserPrivacyAgreedMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SetUserPrivacyAgreedPayload",
        "kind": "LinkedField",
        "name": "setUserPrivacyAgreed",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useSetUserPrivacyAgreedMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SetUserPrivacyAgreedPayload",
        "kind": "LinkedField",
        "name": "setUserPrivacyAgreed",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a89f0d697d99379d36e6dfdd633649a6",
    "id": null,
    "metadata": {},
    "name": "useSetUserPrivacyAgreedMutation",
    "operationKind": "mutation",
    "text": "mutation useSetUserPrivacyAgreedMutation(\n  $input: SetUserPrivacyAgreedInput!\n) {\n  setUserPrivacyAgreed(input: $input) {\n    clientMutationId\n    user {\n      privacyAgreedAt\n      updatedAt\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ee34e8e52e57ae289d3f565b2b070fe7";

export default node;
